import { convertToProcessingState } from '../../../../graphql/tourSceneConverter';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { Scene, SceneGuid, SceneHelper } from '../../types/Scene';
import { IPanorama } from '@ael/core-api';

export type SynchronizeSceneUseCase = {
  sceneGuid: SceneGuid;
  tourId: number;
  panorama: IPanorama;
};

export const synchronizeSceneHandler = async (
  params: SynchronizeSceneUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC
): Promise<Partial<TourBuilderStore>> => {
  const store = getState();
  const result = await services.storageClient.fetchTourSceneByGuid({
    tourId: params.tourId,
    tourSceneGuid: params.sceneGuid,
  });

  if (!result) {
    return store;
  }

  const sceneToUpdate = store.scenes.get(params.sceneGuid);
  if (!sceneToUpdate) {
    return store;
  }

  const processingState = convertToProcessingState(result.hasProcessingFinishedSuccessfully);
  const updatedScene = SceneHelper.changeUnderlyingPanorama(
    sceneToUpdate,
    result.name,
    result.thumbnailUrl,
    processingState,
    result.sceneRenderSettings ?? SceneHelper.getDefaultRenderSettings()
  );

  const newScenes = new Map<SceneGuid, Scene>(store.scenes);
  newScenes.set(updatedScene.guid, updatedScene);

  if (result.sceneRenderSettings) {
    void params.panorama.updateScene(sceneToUpdate.guid, result.sceneRenderSettings);
  }

  return {
    scenes: newScenes,
  };
};
